import { Alert, IconButton, Snackbar, Typography } from '@mui/material'
import { Cross } from 'lucide-react'
import { useCallback, useContext, useEffect, useState } from 'react'
import { ClientEntryContext } from '../utils/context/clientEntry.context'
import { useOpenDoorNotifications } from '../utils/websockets/useOpenDoorNotifications'

const KioskNotificationComponent = () => {
  const { pendingKiosks, openClientForPendingKiosk, askEntry } = useContext(ClientEntryContext)

  interface DoorOpenData {
    storeId?: string | number
    kioskId?: string | number
    storeLabel?: string
  }

  const handleDoorOpen = useCallback(
    (data: DoorOpenData) => {
      const pendingKiosk = {
        kioskId: Number(data.kioskId) || 0,
        storeId: Number(data.storeId) || 0,
        storeLabel: data.storeLabel || `Boutique ${data.storeId}`,
      }

      askEntry(pendingKiosk)
    },
    [askEntry],
  )

  useOpenDoorNotifications(handleDoorOpen)

  const [currentNotification, setCurrentNotification] = useState<{
    id: number
    message: string
  } | null>(null)

  useEffect(() => {
    if (pendingKiosks.length > 0) {
      const firstKiosk = pendingKiosks[0]
      setCurrentNotification({
        id: firstKiosk.storeId,
        message: `Nouvelle demande d'ouverture dans la boutique "${
          firstKiosk.storeLabel || firstKiosk.storeId
        }".`,
      })
    } else {
      setCurrentNotification(null)
    }
  }, [pendingKiosks])

  const handleClose = (openPage: boolean) => {
    setCurrentNotification(null)
    if (pendingKiosks.length > 0) {
      openClientForPendingKiosk(pendingKiosks[0].kioskId, openPage)
    }
  }

  return (
    <div>
      {currentNotification !== null && (
        <Snackbar
          open
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          sx={{
            backgroundColor: 'orange',
            color: '#3E2500',
          }}
        >
          <Alert
            severity="info"
            action={
              <IconButton size="small" color="inherit" onClick={() => handleClose(false)}>
                <Cross fontSize="small" />
              </IconButton>
            }
          >
            <Typography
              variant="body2"
              color="inherit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleClose(true)}
              sx={{
                '&:hover': {
                  textDecoration: 'underline', // Souligner au survol
                },
              }}
            >
              {currentNotification.message}
            </Typography>
          </Alert>
        </Snackbar>
      )}
    </div>
  )
}

export default KioskNotificationComponent
